export const engageConstants = {
    ENGAGE_REQUEST: 'ENGAGE_REQUEST',
    ENGAGE_SUCCESS: 'ENGAGE_SUCCESS',
    ENGAGE_FAILURE: 'ENGAGE_FAILURE'
};